export default class AnalyticsTracker {
    private _isHotjarEnabled(): boolean {
        // @ts-ignore
        return typeof hj !== 'undefined';
    }

    private _isMatomoEnabled(): boolean {
        // @ts-ignore
        return typeof _paq !== 'undefined';
    }

    public fireAllTrackingEvents(eventCategory: string, eventName: string): void {
        this.fireHotjarTrackingEvent(eventCategory, eventName);
        this.fireMatomoTrackingEvent(eventCategory, eventName);
    }

    public fireHotjarTrackingEvent(eventCategory: string, eventName: string): void {
        if (!this._isHotjarEnabled()) {
            return;
        }

        //console.log('fireHotjarTrackingEvent', eventCategory, eventName)

        try {
            // @ts-ignore
            hj('event', `${eventCategory} - ${eventName}`);
        } catch (e) {
            if (e instanceof ReferenceError) {
                // Handle error as necessary
            }
        }
    }

    // CAUTION: Hotjar survey eventets MUST NOT contain spaces -> so use this event!
    public fireHotjarTrackingEventSurvey(eventCategory: string, eventName: string): void {
        if (!this._isHotjarEnabled()) {
            return;
        }

        //console.log('fireHotjarTrackingEventSurvey', eventCategory, eventName);

        try {
            // @ts-ignore
            hj('event', `${eventCategory}${eventName}`);
        } catch (e) {
            if (e instanceof ReferenceError) {
                // Handle error as necessary
            }
        }
    }

    public fireMatomoTrackingEvent(eventCategory: string, eventName: string): void {
        if (!this._isMatomoEnabled()) {
            return;
        }

        //console.log('fireMatomoTrackingEvent', eventCategory, eventName);

        try {
            // @ts-ignore
            _paq.push(['trackEvent', eventCategory, eventName]);
        } catch (e) {
            if (e instanceof ReferenceError) {
                // Handle error as necessary
            }
        }
    }
}
